/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../../clients/baseClient'
import type { RequestConfig, ResponseErrorConfig } from '../../../../clients/baseClient'
import type {
  CreateWorkplaceApiV1CollaborationAppWorkplacePostMutationRequest,
  CreateWorkplaceApiV1CollaborationAppWorkplacePostMutationResponse,
  CreateWorkplaceApiV1CollaborationAppWorkplacePostQueryParams,
  CreateWorkplaceApiV1CollaborationAppWorkplacePostHeaderParams,
  CreateWorkplaceApiV1CollaborationAppWorkplacePost422,
} from '../../types/CreateWorkplaceApiV1CollaborationAppWorkplacePost.ts'
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query'
import { useMutation } from '@tanstack/react-query'

export const createWorkplaceApiV1CollaborationAppWorkplacePostMutationKey = () => [{ url: '/api/v1/collaboration_app/workplace' }] as const

export type CreateWorkplaceApiV1CollaborationAppWorkplacePostMutationKey = ReturnType<typeof createWorkplaceApiV1CollaborationAppWorkplacePostMutationKey>

/**
 * @summary Create Workplace
 * {@link /api/v1/collaboration_app/workplace}
 */
export async function createWorkplaceApiV1CollaborationAppWorkplacePost(
  data: CreateWorkplaceApiV1CollaborationAppWorkplacePostMutationRequest,
  params?: CreateWorkplaceApiV1CollaborationAppWorkplacePostQueryParams,
  headers?: CreateWorkplaceApiV1CollaborationAppWorkplacePostHeaderParams,
  config: Partial<RequestConfig<CreateWorkplaceApiV1CollaborationAppWorkplacePostMutationRequest>> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data
  const res = await request<
    CreateWorkplaceApiV1CollaborationAppWorkplacePostMutationResponse,
    ResponseErrorConfig<CreateWorkplaceApiV1CollaborationAppWorkplacePost422>,
    CreateWorkplaceApiV1CollaborationAppWorkplacePostMutationRequest
  >({
    method: 'POST',
    url: `/api/v1/collaboration_app/workplace`,
    params,
    data: requestData,
    ...requestConfig,
    headers: { ...headers, ...requestConfig.headers },
  })
  return res.data
}

/**
 * @summary Create Workplace
 * {@link /api/v1/collaboration_app/workplace}
 */
export function useCreateWorkplaceApiV1CollaborationAppWorkplacePost<TContext>(
  options: {
    mutation?: UseMutationOptions<
      CreateWorkplaceApiV1CollaborationAppWorkplacePostMutationResponse,
      ResponseErrorConfig<CreateWorkplaceApiV1CollaborationAppWorkplacePost422>,
      {
        data: CreateWorkplaceApiV1CollaborationAppWorkplacePostMutationRequest
        params?: CreateWorkplaceApiV1CollaborationAppWorkplacePostQueryParams
        headers?: CreateWorkplaceApiV1CollaborationAppWorkplacePostHeaderParams
      },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<CreateWorkplaceApiV1CollaborationAppWorkplacePostMutationRequest>> & { client?: typeof fetch }
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? createWorkplaceApiV1CollaborationAppWorkplacePostMutationKey()

  return useMutation<
    CreateWorkplaceApiV1CollaborationAppWorkplacePostMutationResponse,
    ResponseErrorConfig<CreateWorkplaceApiV1CollaborationAppWorkplacePost422>,
    {
      data: CreateWorkplaceApiV1CollaborationAppWorkplacePostMutationRequest
      params?: CreateWorkplaceApiV1CollaborationAppWorkplacePostQueryParams
      headers?: CreateWorkplaceApiV1CollaborationAppWorkplacePostHeaderParams
    },
    TContext
  >(
    {
      mutationFn: async ({ data, params, headers }) => {
        return createWorkplaceApiV1CollaborationAppWorkplacePost(data, params, headers, config)
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  )
}